<div [formGroup]="form">
      <div class="input-group">
   <input 
  [attr.type]="showPassword ? 'text' : 'password'" 
  autocomplete="off" 
  [id]="field.name" 
  [name]="field.name"
  [maxlength]="field.maxLength" 
  [formControlName]="field.name" autocomplete="new-password"
  class="form-control input-font"
  [placeholder]="field.placeholder">

       <span class="input-group-text bl-0">
          @if(!showPassword){
        <img src="assets/images/eye_ic.svg" (click)="togglePassword()">
          }
        @if(showPassword){
        <img  src="assets/images/eye_close_ic.svg" (click)="togglePassword()">
        }
    </span>
    <!-- <div class="input-group-append cursor_pointer" > -->
    <!-- <span class="input-group-text bl-0"> -->

    <!-- <img *ngIf="showPassword" src="../../../assets/images/eye_close_ic.svg"> -->
    <!-- </span> -->
    </div>
    @if(form.get(field.name)?.invalid && form.get(field.name)?.touched ){

        @if(!(form.get(field.name)?.errors?.['mustMatch'] && form.get(field.name)?.touched)){
    <small class="invalid-feedback">{{field.label}} is required</small>
        }

    }
       @if(form.get(field.name)?.errors?.['mustMatch']){
      <small class="invalid-feedback">  {{field.label}} must match</small>

<!-- </div> -->
    } 
   


</div>